var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__caret--wide--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 17a1 1 0 01-.625-.219l-10-8A1 1 0 012 7h20a1 1 0 01.625 1.781l-10 8A1 1 0 0112 17zM4.851 9L12 14.719 19.15 9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }